import { render, staticRenderFns } from "./CategoriaDeFitossanidade.vue?vue&type=template&id=07a1b5f5&scoped=true"
import script from "./CategoriaDeFitossanidade.vue?vue&type=script&lang=js"
export * from "./CategoriaDeFitossanidade.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=07a1b5f5&prod&scoped=true&lang=css&external"
import style1 from "./CategoriaDeFitossanidade.vue?vue&type=style&index=1&id=07a1b5f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a1b5f5",
  null
  
)

export default component.exports